import React from 'react';

const Development = {
	FB_APP_ID: "1298993600235375",
	GOOGLE_CLIENT_ID: "352086129390-nph4r09st93tpc8ql0ppn66s2r6bbhqa.apps.googleusercontent.com",
	BASE_API_URL: "http://127.0.0.1:8080",
	HOME_PAGE_BANNERS: [
		{img: "http://127.0.0.1:8080/profile_pics/banners/Pari Banner1.jpg", url: "/store/Random-Nepali", title: "Random Nepali - Merchandise"},
		{img: "http://127.0.0.1:8080/profile_pics/banners/Girish Khatiwada Banner2.jpg", url: "/store/Mr-Foodie-Nepal", title: "Mr. Foodie Nepal - Merchandise"}
	],
	TOP_ARTISTS: [
		{id: 191, username: 'Abiraj Tamang', userType: "DESIGNER"},
		{id: 190, username: 'Something', userType: "DESIGNER"},
		{id: 318, username: 'Some Regular User', userType: "DESIGNER"}
	],
	ADMIN_USER_ID: 2,

	CUSTOM_PRODUCTS: {
		MUSIC_PLAQUE: [64, 68],
		PHOTO_FRAME: [69]
	},
	ACRYCLIC_MUSIC_PLAQUE: 64,
	CUSTOM_FRAME_PRODUCT: 69,
	CYBERSOURCE_FORM_URL: "https://testsecureacceptance.cybersource.com/pay"
};

const LocalServer = {
	FB_APP_ID: "1298993600235375",
	GOOGLE_CLIENT_ID: "352086129390-nph4r09st93tpc8ql0ppn66s2r6bbhqa.apps.googleusercontent.com",
	BASE_API_URL: "http://127.0.0.1:8080",

	HOME_PAGE_BANNERS: [
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/Random Banner1.jpg", url: "/store/Random-Nepali", title: "Random Nepali - Merchandise"},
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/Foodie Banner3.jpg", url: "/store/Mr-Foodie-Nepal", title: "Mr. Foodie Nepal - Merchandise"}
	],
	TOP_ARTISTS: [
		{id: 191, username: 'Abiraj Tamang'},
		{id: 190, username: 'Something'},
		{id: 318, username: 'Some Regular User'}
	],
	ADMIN_USER_ID: 2,
	CUSTOM_PRODUCTS: {
		MUSIC_PLAQUE: [64, 68],
		PHOTO_FRAME: [69]
	},
	ACRYCLIC_MUSIC_PLAQUE: 64,
	CUSTOM_FRAME_PRODUCT: 69,
	CYBERSOURCE_FORM_URL: "https://testsecureacceptance.cybersource.com/pay"
};


const Production = {
	FB_APP_ID: "306120713289427",
	GOOGLE_CLIENT_ID: "626962822748-8vs5kbmrc9jmp73ekcivja3ib8u507q3.apps.googleusercontent.com",
	BASE_API_URL: "https://api.setocanvas.com",

	HOME_PAGE_BANNERS: [
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/AMTees-Banner.jpg", url: "/store/AM-Tees", title: "AM Tees - Tshirt and Hoodies"},
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/Yatri-Banner.jpg", url: "/store/Yatri-Design", title: "Yatri Design - Merchandise"},
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/ChetanV Banner2.jpg", url: "/store/Chetan-Vlog", title: "Chetan Vlog - Merchandise"},
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/PB Hoodie Banner.JPG", url: "/store/Pari-Store", title: "Pari - Prechya Bajracharya Merchandise"},
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/Girish Khatiwada Banner1.jpg", url: "/store/Gorkhali-Store", title: "Gorkali Store - Girish Khatiwada"},
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/B8Banner2.jpg", url: "/store/B-8Eight", title: "B8Eight - Merchandise"},
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/Foodie Banner3.jpg", url: "/store/Mr-Foodie-Nepal", title: "Mr. Foodie Nepal - Merchandise"},
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/Random Banner1.jpg", url: "/store/Random-Nepali", title: "Random Nepali - Merchandise"},
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/Prashant NKS Banner.jpg", url: "/store/nksPrashant", title: "Prashant NKS - Merchandise"},
		{img: "https://www.setocanvas.com/masi/profile_pics/banners/Dose-of-Ride_social.jpg", url: "/store/Dose-Of-Ride", title: "Dose of Ride - Merchandise"}
	],
	TOP_ARTISTS: [
		{id: 323, username: 'Suraj Maharjan', userType: "DESIGNER"},
		{id: 269, username: 'Prasiddha Shrestha', userType: "DESIGNER"},
		{id: 480, username: 'Sampurnaa Chalize', userType: "DESIGNER"},
		{id: 248, username: 'Siddhant Acharya', userType: "DESIGNER"},

		{id: 463, username: 'Merishna Suwal', userType: "DESIGNER"},
		{id: 182, username: 'Johnson Dhakal', userType: "DESIGNER"},
		
		{id: 533, username: 'D20 Design Labs', userType: "DESIGNER"},
		{id: 625, username: 'Anjal Soti', userType: "DESIGNER"},
		{id: 25, username: 'Ashwin Neupane', userType: "DESIGNER"}
	],
	ADMIN_USER_ID: 2,
	CUSTOM_PRODUCTS: {
		MUSIC_PLAQUE: [1500, 1578],
		PHOTO_FRAME: [1624]
	},
	ACRYCLIC_MUSIC_PLAQUE: 1500,
	CUSTOM_FRAME_PRODUCT: 1624,

	CYBERSOURCE_FORM_URL: "https://secureacceptance.cybersource.com/pay"
};

const Env = {'dev': Development, 
			'prod': Production,
			'localserver': LocalServer}

const APP_ENV = process.env.REACT_APP_ENV;

const CLOTH_SIZES = {
	S: {label: 'Small (38")', shortLabel: 'S (38")', priceAddition: 0},
	M: {label: 'Medium (40")', shortLabel: 'M (40")',priceAddition: 0},
	L: {label: 'Large (42")', shortLabel: 'L (42")',priceAddition: 0},
	XL: {label: 'Extra Large (44")', shortLabel: 'XL (44")',priceAddition: 0}
};

const HOODIE_SIZES = {
	M: {label: 'Medium (40")', shortLabel: 'M (40")', priceAddition: 0},
	L: {label: 'Large (42")', shortLabel: 'L (42")', priceAddition: 0},
	XL: {label: 'Extra Large (44")', shortLabel: 'XL (44")', priceAddition: 0}
};

const SHIRT_SIZES = {
	S: {label: 'Small (38")', shortLabel: 'S (38")', priceAddition: 0},
	M: {label: 'Medium (40")', shortLabel: 'M (40")',priceAddition: 0},
	L: {label: 'Large (42")', shortLabel: 'L (42")',priceAddition: 0},
	XL: {label: 'Extra Large (44")', shortLabel: 'XL (44")',priceAddition: 0}
};

const SWEAT_SHIRT_SIZES = {
	M: {label: 'Medium (40")', shortLabel: 'M (40")', priceAddition: 0},
	L: {label: 'Large (42")', shortLabel: 'L (42")', priceAddition: 0},
	XL: {label: 'Extra Large (44")', shortLabel: 'XL (44")', priceAddition: 0}
};

const JACKET_SIZES = {
	S: {label: 'Small (32")', shortLabel: 'S (32")', priceAddition: 0},
	M: {label: 'Medium (34")', shortLabel: 'M (34")', priceAddition: 0},
	L: {label: 'Large (36")', shortLabel: 'L (36")', priceAddition: 0},
	XL: {label: 'Extra Large (38")', shortLabel: 'XL (38")', priceAddition: 0},
	XXL: {label: 'XX Large (40")', shortLabel: 'XXL (40")', priceAddition: 0}
};

//in photo frame, price and margin increases per size
const PHOTO_FRAME_SIZES = {
	S: {label: 'Small (8" x 11")', shortLabel: 'S (8" x 11")', priceAddition: 0},
	M: {label: 'Medium (11" x 15")', shortLabel: 'M (11" x 15")', priceAddition: 400},
	L: {label: 'Large (13" x 18")', shortLabel: 'L (13" x 18")', priceAddition: 1400},
	XL: {label: 'Extra Large (15" x 21")', shortLabel: 'XL (15" x 21")', priceAddition: 1800}
};

const NO_SIZE = {
	NA: {label: "Regular", shortLabel: "R", priceAddition: 0}
};

const PAPER_SIZE = {
	A4: {label: 'A4 (8.14" x 11.34")', shortLabel: 'A4 (8.14" x 11.34")', priceAddition: 0}
};



const PRODUCT_TYPES = {
	T_SHIRT: {val: "T_SHIRT", url: "tshirt", label: "T-Shirt", previewRequired: true,
			basePrice: 1000, available: true, 
			psdTemplateUrl: "https://drive.google.com/open?id=1VOaGPFNMeViqfqdkwy0WGxns_CzthR2o",
			SIZE: CLOTH_SIZES,
			hasImmediateDelivery: false},

	SWEAT_SHIRT: {val: "SWEAT_SHIRT", url: "sweatshirt", label: "Sweatshirt", previewRequired: true,
			basePrice: 1500, available: true, psdTemplateUrl: "https://drive.google.com/file/d/1uL7RvgMuou_3WOsl6_LOJKB1oOcu-Vrj/view?usp=sharing",
			SIZE: SWEAT_SHIRT_SIZES, hasImmediateDelivery: false},
			
	HOODIES: {val: "HOODIES", url: "hoodies", label: "Hoodies", previewRequired: true, 
			basePrice: 1800, available: true, psdTemplateUrl: "https://drive.google.com/file/d/1EX4Qgx_IWaucC1J78B7lSUeCNdPy_YNj/view?usp=sharing",
			SIZE: HOODIE_SIZES, hasImmediateDelivery: false},

	//remove it later, added to support backward compatibility after adding Art Frame
	PHOTO_FRAME: {val: "PHOTO_FRAME", url: "frame", label: "Frame", previewRequired: true,
			basePrice: 1200, available: true, psdTemplateUrl: "https://drive.google.com/file/d/1oggNf0ghLa6de9dtvtjeIo35draVlNYq/view?usp=sharing",
			SIZE: PHOTO_FRAME_SIZES, hasImmediateDelivery: false,
			deliveryLocationType: {
					INSIDE_KTM_VALLEY: {val: "INSIDE_KTM_VALLEY", label: "Inside KTM Valley, Nepal", extraCost: 100.0}, 
					OUTSIDE_KTM_VALLEY: {val: "OUTSIDE_KTM_VALLEY", label: "Outside KTM Valley, Nepal", extraCost: 350.0}
				}
			},

	OLD_PHOTO_FRAME: {val: "PHOTO_FRAME", url: "photoframe", label: "Photo Frame", previewRequired: true,
			basePrice: 1200, available: false, psdTemplateUrl: "https://drive.google.com/file/d/1oggNf0ghLa6de9dtvtjeIo35draVlNYq/view?usp=sharing",
			SIZE: PHOTO_FRAME_SIZES, hasImmediateDelivery: false},
			
	
	PILLOW: {val: "PILLOW", url: "pillow", label: "Pillow", previewRequired: false,
			basePrice: 1500, available: false,
			SIZE: NO_SIZE, hasImmediateDelivery: false},
	
	

	PAINTING: {val: "PAINTING", url: "painting", label: "Painting", previewRequired: false,
			basePrice: 1000, available: true, psdTemplateUrl: "",
			SIZE: NO_SIZE, hasImmediateDelivery: false},
	
	SKETCH: {val: "SKETCH", url: "sketch", label: "Sketch", previewRequired: false,
			basePrice: 1000, available: true, psdTemplateUrl: "",
			SIZE: NO_SIZE, hasImmediateDelivery: false},
	
	MUSIC_PLAQUE: {val: "MUSIC_PLAQUE", url: "music-plaque", label: "Music Plaque", previewRequired: false,
			basePrice: 1200, available: false, psdTemplateUrl: "",
			SIZE: PAPER_SIZE, hasImmediateDelivery: false,
			deliveryLocationType: {
				INSIDE_KTM_VALLEY: {val: "INSIDE_KTM_VALLEY", label: "Inside KTM Valley, Nepal", extraCost: 100.0}, 
				OUTSIDE_KTM_VALLEY: {val: "OUTSIDE_KTM_VALLEY", label: "Outside KTM Valley, Nepal", extraCost: 250.0}
			}
		},

	JACKET: {val: "JACKET", url: "jacket", label: "Jacket", previewRequired: false,
			basePrice: 2500, available: true, psdTemplateUrl: "",
			SIZE: JACKET_SIZES, hasImmediateDelivery: true},

	FASHION_DESIGNER_WEAR: {val: "FASHION_DESIGNER_WEAR", url: "fashion-wear", label: "Fashion Designer Wear", 
			previewRequired: true,
			basePrice: 1500, available: true, psdTemplateUrl: "",
			SIZE: SHIRT_SIZES, hasImmediateDelivery: false},
	
	OTHER: {val: "OTHER", url: "other", label: "Other", 
			previewRequired: false,
			basePrice: 50, available: true, psdTemplateUrl: "",
			SIZE: NO_SIZE, hasImmediateDelivery: false}
};


const ARTWORK_TYPES = {
	DIGITAL_ART: {val:"DIGITAL_ART", label: "Graphic Art", 
					supportedProductTypes: [PRODUCT_TYPES.SWEAT_SHIRT.val, 
											PRODUCT_TYPES.T_SHIRT.val, 
											PRODUCT_TYPES.HOODIES.val,
											PRODUCT_TYPES.PILLOW.val,
											PRODUCT_TYPES.PHOTO_FRAME.val,
											PRODUCT_TYPES.MUSIC_PLAQUE.val
										]}, 
	PHOTOGRAPH: {val: "PHOTOGRAPH", label: "Photograph",
					supportedProductTypes: [PRODUCT_TYPES.T_SHIRT.val, PRODUCT_TYPES.PILLOW.val, PRODUCT_TYPES.PHOTO_FRAME.val]},
	PHYSICAL_ART: {val: "PHYSICAL_ART", label: "Physical Art",
					supportedProductTypes: [PRODUCT_TYPES.PAINTING.val, PRODUCT_TYPES.SKETCH.val, 
											PRODUCT_TYPES.PHOTO_FRAME.val, 
											PRODUCT_TYPES.FASHION_DESIGNER_WEAR.val,
											PRODUCT_TYPES.OTHER.val]}
}




const USER_TYPE = {
	ADMIN: "ADMIN",
	DESIGNER: "DESIGNER",
	INFLUENCER: "INFLUENCER",
	PHOTOGRAPHER: "PHOTOGRAPHER",
	FASHION_DESIGNER: "FASHION_DESIGNER",
	REGULAR: "REGULAR",
	SALES: "SALES"
};

const PRODUCT_STATE = {
	PENDING_APPROVAL: "PENDING_APPROVAL",
	APPROVED: "APPROVED",
	UNPUBLISHED: "UNPUBLISHED",
	ARCHIVED: "ARCHIVED"
};

const ORDER_STATE = {
	ORDER_PLACED: {label: "Order Placed", value: "ORDER_PLACED"},
	ORDER_CONFIRMED: {label: "Order Confirmed", value: "ORDER_CONFIRMED"},
	SHIPPING: {label: 'Shipping', value: "SHIPPING"},
	DELIVERED: {label: 'Delivered', value: "DELIVERED"},
	DELIVERED_CLOSED: {label: 'Closed', value: "DELIVERED_CLOSED"},
	CANCELLED: {label: 'Cancelled', value: "CANCELLED"}
};



const regularDelivery = <span style={{color: '#596161'}}>Regular Delivery <i className='fa fa-motorcycle' aria-hidden='true'></i></span>;
const immediateDelivery = <span style={{color: '#596161'}}>Immediate Delivery <i className='fa fa-space-shuttle' aria-hidden='true'></i></span>;

const DELIVERY_TYPE = {REGULAR: {val: "REGULAR", label: regularDelivery, extraCost: 0.0}, 
						IMMEDIATE: {val: "IMMEDIATE", label: immediateDelivery, extraCost: 100.0}
					};

const DELIVERY_LOCATION_TYPE = {INSIDE_KTM_VALLEY: {val: "INSIDE_KTM_VALLEY", label: "Inside KTM Valley, Nepal", extraCost: 100.0}, 
								INSIDE_RING_ROAD: {val: "INSIDE_RING_ROAD", label: "Inside Ring Road, KTM Valley, Nepal", extraCost: 100.0}, 
								OUTSIDE_RING_ROAD: {val: "OUTSIDE_RING_ROAD", label: "Outside Ring Road, KTM Valley, Nepal", extraCost: 150.0}, 
								OUTSIDE_KTM_VALLEY: {val: "OUTSIDE_KTM_VALLEY", label: "Outside KTM Valley, Nepal", extraCost: 250.0}
								};

//these are static for the nav bar
const TOP_INFLUENCERS = [
	{username: 'Girish Khatiwada', storeName: 'Gorkhali Store'},
	{username: 'Prechya Bajracharya', storeName: 'Pari Store'},
	{username: 'Chetan Raj Karki', storeName: 'Chetan Vlog'},
	{username: 'Beestdesigns', storeName: 'Beestdesigns'},
	{username: 'B-8Eight', storeName: 'B 8Eight'},
	{username: 'Mr. Foodie Nepal', storeName: 'Mr Foodie Nepal'},
	{username: 'Dose Of Ride', storeName: 'Dose Of Ride'},
	{username: 'Random Nepali', storeName: 'Random Nepali'},
	{username: 'Ashish Prasai', storeName: 'Prankster Revival'},
	{username: 'Buddhi Tamang', storeName: 'Buddhi Tamang'},
	{username: 'Prashant NKS', storeName: 'nksPrashant'}
];

const TOP_STORES = [
		{storeName: 'Comedy Circle'},
		{storeName: 'MMA Merch Nepal'}, 
		{storeName: 'AM Tees'},
		{storeName: 'TShirt Guy'},
		{storeName: 'Yatri Design'},
		{storeName: 'loveKUSH Tee'},
		{storeName: 'The Doers Nepal'},
		{storeName: 'Chill And Green'},
		{storeName: 'Celebrate Nepal'}];


const TOP_TAGS = [
	{name: "funny", value: "Funny"},
	{name: "profession", value: "Professions"},
	{name: "travel", value: "Travel"},
	{name: "gods", value: "Gods"},
	{name: "nepal", value: "Nepal"},
	{name: "quote", value: "Quote"},
	{name: "animal", value: "Animal"},
	{name: "superhero", value: "Superhero"},
];

const SIGN_UP_FORMS = {
	LOGIN_FORM: "LOGIN",
	REGISTER_FORM: "REGISTER",
	FORGOT_PASSWORD: "FORGOT_PASSWORD",
	SOCIAL_LOGIN: "SOCIAL_LOGIN"
}


const PAYMENT_OPTIONS = {
	COD: {val: "COD", label: "Cash On Delivery"},
	ESEWA: {val: "ESEWA", label: "eSewa", image: "/images/payment/eSewa.png"},
	QR_CODE_SCAN: {val: "QR_CODE_SCAN", label: "QR Code Scan", image: "/images/payment/fonePay.png"},
	VISA_MASTER: {val: "VISA_MASTER", label: "Credit/Debit Card"},
	BANK_TRANSER: {val: "BANK_TRANSER", label: "Bank Transfer", image: "/images/payment/bankTransfer.png"}
};

const AppConstants = {
	APP_NAME: "Seto Canvas",
	CONTACT_EMAIL: "setocanvas@gmail.com",

	BASE_API_URL: Env[APP_ENV].BASE_API_URL,

	CUSTOM_PRODUCTS: Env[APP_ENV].CUSTOM_PRODUCTS,
	ACRYCLIC_MUSIC_PLAQUE: Env[APP_ENV].ACRYCLIC_MUSIC_PLAQUE,
	CUSTOM_FRAME_PRODUCT: Env[APP_ENV].CUSTOM_FRAME_PRODUCT,
	
	CYBERSOURCE_FORM_URL: Env[APP_ENV].CYBERSOURCE_FORM_URL,

	FB_APP_ID: Env[APP_ENV].FB_APP_ID,
	GOOGLE_CLIENT_ID: Env[APP_ENV].GOOGLE_CLIENT_ID,

	HOME_PAGE_BANNERS: Env[APP_ENV].HOME_PAGE_BANNERS,
	
	WEBSITE: 'https://www.setocanvas.com',
	USER_ADDRESS_KEY: "USER_ADDRESS_KEY",

	SIZE_INCREMENT: 2,

	ADMIN_USER_ID: Env[APP_ENV].ADMIN_USER_ID,
	
	USER_TYPE: USER_TYPE,
	PRODUCT_STATE: PRODUCT_STATE,

	ORDER_STATE: ORDER_STATE,
	PRODUCT_TYPES: PRODUCT_TYPES,
	ARTWORK_TYPES: ARTWORK_TYPES,

	WHATS_APP: '9840843155',
	CONTACT_NUMBER: '9840843155, 9803947082',
	DELIVERY_LOCATION_TYPE: DELIVERY_LOCATION_TYPE,
	DELIVERY_TYPE: DELIVERY_TYPE,

	FB_PAGE_ID: "417097095539625",

	DEFAULT_PRODUCT_PAGE_SIZE: 15,

	DEFAULT_PRODUCT_TAGS: ['funny', 'cute', 'cartoon', 'animal', 'superhero', 'music', 'movie', 'anime', 'shows', 
							'local', 'nepal', 'travel', 'food', 'adventure', 'gods', 'mma', 'sports', 'bike', 'quotes', 'abstract',],


	TOP_INFLUENCERS: TOP_INFLUENCERS,
	TOP_ARTISTS: Env[APP_ENV].TOP_ARTISTS,
	TOP_STORES: TOP_STORES,
	TOP_TAGS: TOP_TAGS,

	BITLY_API_KEY: "R_415998193e644457aaab67924e93fa52",
	BITLY_LOGIN: "setocanvas",


	FB_PAGE: "https://www.facebook.com/setocanvascom/",
	INSTA_PAGE: "https://www.instagram.com/setocanvas/",
	YT_CHANNEL: "https://www.youtube.com/channel/UCjSM4-8VZ8NcvljZoQ_3pnA",
	FB_GROUP: "https://www.facebook.com/groups/1664344370379950",

	SIGN_UP_FORMS: SIGN_UP_FORMS,

	LOGIN_TO_CONTINUE_MSG: "Use one of the options to Login/Sign Up.",

	PAYMENT_OPTIONS: PAYMENT_OPTIONS,

	BULK_ORDER_DISCOUNT_PCT : 0.15,
	BULK_MINMUM_QUANTITY : 10
};

export default AppConstants;




// WEBPACK FOOTER //
// ./src/AppConstants.js